export default "../img/overlay-icon-play.svg";